<div #background [style.background]="lineBackground" width="100%" height="100%">
  <button #innerButton width="100%" height="100%" [ngClass]="{'disabled-class': wizDisabled}"
    class="innerfocus-class" [disabled]='wizDisabled'
    (click)="onClick()" (dblclick)="onDoubleClick()" (focus)="wizOnFocus()">
      <div class="inner-button" width="100%">
          <wiz-icon class="inner-icon" [hidden]="!wizIcon" style="color: inherit;">{{wizIcon}}</wiz-icon>
          <!-- <mat-icon class="inner-icon" [hidden]="!wizIcon" style="color: inherit;">{{wizIcon}}</mat-icon> -->
          <div class="label-container" width="100%">
            <wiz-label class="innerLabel" *ngIf="wizLabel" [wizTooltip]="fullDesc" [tooltipEnable]="true"
              [wizLabel]="wizLabel" width="100%" [wizTextBehavior]="'truncate'"></wiz-label>
          </div>
          <div *ngIf="showDelete" class="clear-container" height="100%" >
            <mat-icon class="clear-icon" #innerClearIcon wizNotFocusable (click)="onClear($event)" width="10px" height="10px">close</mat-icon>
          </div>
      </div>
  </button>
</div>
